import React, { useState, useEffect } from "react";
import Navbar from "../../Components/Navbar/navbar";
import Formcomponent from "../../Components/Performance/FormA/Formcomponent";
import { PerformanceJson } from "./Peformancejson";
import { PerformanceJsonB } from "./Peformancejson";
import "./performance.css";
// import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import PerformanceHeader from "./PerformanceHeader/PerformanceHeader";
// import FormBcard from "../../Components/Performance/FormB/FormBcard";
// import RequestJson from "./Request/Requestjson";
import FormcomponentC from "../../Components/Performance/FormC/FormCcomponent";
// import FormcomponentD from "../../Components/Performance/FormD/Formcomp";
// import FormcomponentDb from "../../Components/Performance/FormD/Formcomponent";
// import FormcomponentE from "../../Components/Performance/FormE/Formcomponent";
// import Sanctionform from "../../Components/Performance/FormE/Sanctionform";
// import FormcomponentF from "../../Components/Performance/FormF/Formcomponent";
import FormBcomponent from "../../Components/Performance/FormA/FormBcomponent";
import PerformanceScore from "./performanceScore";
import FormD from "../../Components/Performance/FormD/FormD";

const Performance = () => {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const [tab, setTab] = useState(0);

  const handleButnClick = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    setTab(tab + 1);
    if (tab >= 7) {
      setTab(6);
    }
  };

  const handlePrevClick = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    setTab(tab - 1);
  };

  const [formA, setFormA] = useState({
    socreobtained: 0,
    scoreobtainable: 0,
  });

  const [formB, setFormB] = useState({
    socreobtained: 0,
    scoreobtainable: 0,
  });

  var const_percentage = 100;

  const FormA_Clientratings = (incoming) => {
    setFormA({ ...formA, ...incoming });
  };

  const FormB_Clientratings = (incoming) => {
    setFormB({ ...formB, ...incoming });
  };

  let total_score = (
    ((parseInt(formA.socreobtained) + parseInt(formB.socreobtained)) /
      (parseInt(formA.scoreobtainable) + parseInt(formB.scoreobtainable))) *
    const_percentage
  ).toFixed(0);

  return (
    <div className="employee-container">
      <Navbar tabtext="Performance Appraisal" currentab="others" />
      <div className="appraisal-form-head">Performance Appraisal Form</div>

      <PerformanceHeader />

      {
        tab === 0 ? (
          <div className="w-full bg-[white] min-h-screen p-[30px] px-[20px] flex flex-col gap-3">
            <div className="w-full text-center p-4 bg-[#ccc] text-[20px] tracking-[1px] font-[500]">
              Performance Appraisal & Development
            </div>

            <div className="w-full flex-col">
              <div className="flex w-full row_class">
                <div
                  data-label="#ID"
                  className="flex w-[40%] min-w-[135px] p-2 py-3 text-[14px] text-start cell_class mobile:text-[13px]"
                >
                  Appraisal Year:
                </div>
                <div
                  data-label="Country"
                  className="flex w-full p-2 py-3 text-[14px] text-start cell_class"
                ></div>
              </div>

              <div className="flex w-full row_class">
                <div
                  data-label="#ID"
                  className="flex w-[40%] min-w-[135px] p-2 py-3 text-[14px] text-start cell_class mobile:text-[13px]"
                >
                  Name of Staff:
                </div>
                <div
                  data-label="Country"
                  className="flex w-full p-2 py-3 text-[14px] text-start cell_class"
                ></div>
              </div>

              <div className="flex w-full row_class">
                <div
                  data-label="#ID"
                  className="flex w-[40%] min-w-[135px] p-2 py-3 text-[14px] text-start cell_class mobile:text-[13px]"
                >
                  Department/Location:
                </div>
                <div
                  data-label="Country"
                  className="flex w-full p-2 py-3 text-[14px] text-start cell_class"
                ></div>
              </div>

              <div className="flex w-full row_class">
                <div
                  data-label="#ID"
                  className="flex w-[40%] min-w-[135px] p-2 py-3 text-[14px] text-start cell_class mobile:text-[13px]"
                >
                  Designation:
                </div>
                <div
                  data-label="Country"
                  className="flex w-full p-2 py-3 text-[14px] text-start cell_class"
                ></div>
              </div>

              <div className="flex w-full row_class">
                <div
                  data-label="#ID"
                  className="flex w-[40%] min-w-[135px] p-2 py-3 text-[14px] text-start cell_class mobile:text-[13px]"
                >
                  Line Manager:
                </div>
                <div
                  data-label="Country"
                  className="flex w-full p-2 py-3 text-[14px] text-start cell_class"
                ></div>
              </div>
            </div>

            <div className="flex flex-col gap-2">
              <p>
                <b>Basis for Performance Appraisal and Development</b>
              </p>
              <span>
                The Performance Appraisal system enables the performance of all
                staff to be recognised through feedback, career development etc.
                It also provides performance history that is not dependent on
                human memory and allows clearer articulation of performance
                expectation. Majority of staff will have had a successful year
                in which their job performance has been as expected and in which
                some normal requirements may have been exceeded. Following
                evaluation, a natural focus is development for the coming year,
                and it is important that the development objectives are
                discussed and specified.
              </span>
            </div>

            <div className="flex flex-col gap-2">
              <p>
                <b>Deadline for submission</b>
              </p>
              <span>
                An essential part of successful performance management is
                completing the evaluation soon after the end of the reporting
                year. The deadline is ___________________________________. This
                means that all sections must be completed before this date and
                the line manager, member of staff and countersigning manager
                must work together to ensure this deadline is met.
              </span>
            </div>

            <div className="flex flex-col gap-2">
              <p>
                <b>Instruction on Assessment</b>
              </p>
              <div className="flex flex-col gap-1">
                Overall rating of performance against objectives: Please rate
                the individual on the following scale for each criterion.
                <p>
                  4 = Excellent performance signifying 76 – 100% of objectives
                  are met{" "}
                </p>
                <p>
                  3 = Good performance signifying 50 – 75% of objectives are met{" "}
                </p>
                <p>
                  2 = Fair performance signifying 30 – 49% of objective are met
                </p>
                <p>
                  1 = Unsatisfactory signifying less than 30% objective are met
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-2">
              <p>
                <b>(Part A, B and C must be completed by line manager)</b>
              </p>
              <span>
                Part A & B are a summary of the Manager’s evaluation of the
                individual’s performance. All parts must be completed. The
                report must describe the quality of performance and include any
                areas where there is room for improvement. Comments must be
                supported by examples. For staff with line management
                responsibilities, these parts must contain evidence of
                performance in managing staff and account should be taken of any
                upward appraisals.
              </span>
            </div>

            <div className="button-main-containerbox">
              <div className="button-main-contain" onClick={handlePrevClick}>
                {/* <button>PREVIOUS</button> */}
              </div>

              <div className="button-main-contain" onClick={handleButnClick}>
                <button>NEXT</button>
              </div>
            </div>
          </div>
        ) : tab === 1 ? (
          <div className="performance-form-container">
            <div className="w-full text-center p-4 bg-[#ccc] flex items-center justify-center text-[20px] tracking-[1px] font-[500]">
              PART A:{" "}
              <p className="ml-4 text-[20px]">
                PERFORMANCE OBJECTIVES EVALUATION
              </p>
            </div>

            <div className="text-[13px] font-[500] italic">
              List the objectives that the appraisee set out to achieve in the
              past 12 months (or the period covered by this appraisal -
              typically these objectives will have been carried forward from the
              previous appraisal record) with the measures or standards agreed -
              against each comment on achievement or otherwise, with reasons
              where appropriate.
            </div>

            <Formcomponent
              jsonarray={PerformanceJson}
              clientratings={FormA_Clientratings}
            />

            <div className="button-main-containerbox">
              <div className="button-main-contain" onClick={handlePrevClick}>
                <button>PREVIOUS</button>
              </div>

              <div className="button-main-contain" onClick={handleButnClick}>
                <button>NEXT</button>
              </div>
            </div>
          </div>
        ) : tab === 2 ? (
          <div className="performance-form-container">
            <div className="w-full text-center p-4 bg-[#ccc] flex items-center justify-center text-[20px] tracking-[1px] font-[500]">
              PART B: <p className="ml-4 text-[20px]">OVERALL PERFORMANCE</p>
            </div>

            <FormBcomponent
              jsonarray={PerformanceJsonB}
              clientratings={FormB_Clientratings}
            />

            <div className="bg-gray-200 p-4 rounded-md w-full">
              <div className="flex items-start justify-center items-center">
                <div className="text-[14px] font-500 flex justify-center items-center text-lg h-full mr-2 font-semibold mr-2">
                  % TOTAL RATING =
                </div>

                <div className="flex flex-col justify-center items-center">
                  <div className=" pb-1 mb-1 numerator_class text-[14px] font-500">
                    TOTAL MARK OBTAINED (overall for part A & B) X 100
                  </div>
                  <div className="text-[14px] font-500">
                    TOTAL MARK OBTAINABLE (for A & B)
                  </div>
                </div>

                <b>
                  <p className="mx-2 font-bold">=</p>
                </b>

                <div className="flex flex-col justify-center items-center">
                  <div className=" pb-1 mb-1 numerator_class text-[14px] font-500">
                    {formA.socreobtained + formB.socreobtained} x{" "}
                    {const_percentage}
                  </div>
                  <div className="text-[14px] font-500">
                    {formA.scoreobtainable + formB.scoreobtainable}
                  </div>
                </div>

                <b>
                  <p className="mx-2 font-bold">=</p>
                </b>

                <div className="flex flex-col justify-center items-center">
                  <div className=" pb-1 mb-1 text-[16px] font-[900]">
                    {isNaN(total_score) ? 0 : parseInt(total_score, 10)}%
                  </div>
                </div>
              </div>

              <PerformanceScore score={total_score} />
            </div>

            <div className="button-main-containerbox">
              <div className="button-main-contain" onClick={handlePrevClick}>
                <button>PREVIOUS</button>
              </div>

              <div className="button-main-contain" onClick={handleButnClick}>
                <button>NEXT</button>
              </div>
            </div>
          </div>
        ) : tab === 3 ? (
          <div className="performance-form-container">
            <div className="w-full text-center p-4 bg-[#ccc] flex items-center justify-center text-[20px] tracking-[1px] font-[500]">
              PART C:{" "}
              <p className="ml-4 text-[20px]">
                PERSONAL DEVELOPMENT PLAN FOR NEXT YEAR
              </p>
            </div>

            <div className="text-[13px] font-[500] italic">
              This section must be completed for all staff. Personal development
              is a key part of performance management as it is essential to
              improving performance. It allows the individual to gain the
              necessary skills, knowledge, and experience to carry out the job
              effectively and to prepare for future career moves. Challenging
              targets are an important part of the personal development plan and
              both the individual and the line manager should be clear about the
              individual’s personal development objectives. You should specify
              below the skills, knowledge and experience identified for further
              development during the coming year.
            </div>

            <FormcomponentC />

            <div className="button-main-containerbox">
              <div className="button-main-contain" onClick={handlePrevClick}>
                <button>PREVIOUS</button>
                {/* <HiOutlineArrowNarrowRight id='arror-right-id'/> */}
              </div>

              <div className="button-main-contain" onClick={handleButnClick}>
                <button>NEXT</button>
                {/* <HiOutlineArrowNarrowRight id='arror-right-id'/> */}
              </div>
            </div>
          </div>
        ) : (
          <div className="performance-form-container">
            <div className="w-full text-center p-4 bg-[#ccc] flex items-center justify-center text-[20px] tracking-[1px] font-[500]">
              PART D:{" "}
              <p className="ml-4 text-[20px]">STAFF MEMBER’S COMMENTS</p>
            </div>

            <FormD />

            <div className="button-main-containerbox">
              <div className="button-main-contain" onClick={handlePrevClick}>
                {/* <button>PREVIOUS</button> */}
              </div>

              <div className="button-main-contain" onClick={handleButnClick}>
                <button>FINISH & SUBMIT</button>
              </div>
            </div>
          </div>
        )

        // : tab === 5 ? (
        //   <div className="performance-form-container">
        //     <span>
        //       PART C - SELF DEVELOPMENT (To be completed by the Appraisee and
        //       verified by Appraiser) (This section carries a weight of 10%)
        //     </span>
        //     <FormcomponentD header="List outstanding accomplishments worthy of mention attributable to you within the appraisal period" />
        //     <FormcomponentD header="Mention at least 2 self-developmental efforts undertaken in the year under review." />

        //     <FormcomponentDb
        //       statuss={false}
        //       header="State the constraints to the performance of your duties during the period under review and how you think these constraints could be removed?"
        //     />

        //     <div className="button-main-containerbox">
        //       <div className="button-main-contain" onClick={handlePrevClick}>
        //         <button>PREVIOUS</button>
        //       </div>

        //       <div className="button-main-contain" onClick={handleButnClick}>
        //         <button>NEXT</button>
        //       </div>
        //     </div>
        //   </div>
        // ) : tab === 6 ? (
        //   <div className="performance-form-container">
        //     <span>PART D - Issues/Sanctions warranting point deduction</span>
        //     <FormcomponentE />
        //     <Sanctionform />

        //     <div className="button-main-containerbox">
        //       <div className="button-main-contain" onClick={handlePrevClick}>
        //         <button>PREVIOUS</button>
        //         {/* <HiOutlineArrowNarrowRight id='arror-right-id'/> */}
        //       </div>

        //       <div className="button-main-contain" onClick={handleButnClick}>
        //         <button>NEXT</button>
        //         {/* <HiOutlineArrowNarrowRight id='arror-right-id'/> */}
        //       </div>
        //     </div>
        //   </div>
        // ) : (
        //   <div className="performance-form-container">
        //     <span>PART E - SUMMARY</span>

        //     <FormcomponentF />

        //     <FormcomponentDb header="Appraisee’s Comment" statuss={true} />

        //     <div className="button-main-containerbox">
        //       <div className="button-main-contain" onClick={handlePrevClick}>
        //         <button>PREVIOUS</button>
        //         {/* <HiOutlineArrowNarrowRight id='arror-right-id'/> */}
        //       </div>

        //       <div className="button-main-contain" onClick={handleButnClick}>
        //         <button>SUBMIT</button>
        //         {/* <HiOutlineArrowNarrowRight id='arror-right-id'/> */}
        //       </div>
        //     </div>
        //   </div>
        // )
      }
    </div>
  );
};

export default Performance;
